import { render, staticRenderFns } from "./DemoIframe.vue?vue&type=template&id=0518c744&scoped=true"
import script from "./DemoIframe.vue?vue&type=script&lang=js"
export * from "./DemoIframe.vue?vue&type=script&lang=js"
import style0 from "./DemoIframe.vue?vue&type=style&index=0&id=0518c744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0518c744",
  null
  
)

export default component.exports